module.exports = __webpack_public_path__ + "img/preview.18e39b77.jpg";